import React from "react";
import { finalCta, contactInfo } from "../data/mock";
import { Button } from "./ui/button";
import { ArrowRight, MessageSquare } from "lucide-react";
import { Reveal } from "../lib/motion";

export const CTASection = () => {
  return (
    <section id="contact" data-testid="cta-section" className="py-28 sm:py-36 bg-[#032e2d] relative grain overflow-hidden border-t border-teal-100/10">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[640px] h-[640px] rounded-full bg-brand-500/10 blur-3xl pointer-events-none" />
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10">
        <Reveal>
          <h2 className="font-display font-semibold text-white tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.08]">
            You don't need to know what <em className=" text-brand-300">the solution</em> is.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-8 text-teal-100/75 leading-relaxed text-base md:text-lg max-w-2xl mx-auto">
            {finalCta.body}
          </p>
        </Reveal>
        <Reveal delay={0.22}>
          <div className="mt-10 flex flex-wrap justify-center items-center gap-4">
            <Button
              onClick={() => window.open(contactInfo.bookingUrl, "_blank", "noopener,noreferrer")}
              data-testid="final-primary-cta"
              className="bg-teal-50 hover:bg-white text-[#032e2d] rounded-full h-13 px-8 py-6 text-base font-medium transition-all duration-300 hover:-translate-y-0.5"
            >
              {finalCta.primaryCta}
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <Button
              onClick={() => window.open(contactInfo.whatsapp, "_blank", "noopener,noreferrer")}
              data-testid="final-whatsapp-cta"
              variant="outline"
              className="rounded-full h-13 px-8 py-6 text-base font-medium border-teal-100/30 bg-transparent text-teal-50 hover:bg-teal-100/10 hover:text-white transition-all duration-300"
            >
              <MessageSquare className="w-4 h-4 mr-2" />
              {finalCta.secondaryCta}
            </Button>
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-8 text-sm text-teal-200/50">
            Or email{" "}
            <a href={`mailto:${contactInfo.email}`} data-testid="final-email-link" className="text-teal-100/80 hover:text-white link-underline">
              {contactInfo.email}
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  );
};
